export const Core = {
    /**
     * copies the values (of all enumerable own properties)
     * @param object
     * @returns {Object}
     */
    clone: function( object ) {
        return Object.assign( {}, object );
    },

    /**
     * @param object
     * @returns {Object} a deep clone of simple objects (ie. no prototypes, functions or circular references)
     */
    deepclone: function( object ) {
        return JSON.parse( JSON.stringify( object ) );
    },

    /**
     * Hint:
     *  result = new Map([...map1, ...map2]) don't work right now (2019-02-11, Chrome)
     *
     * @param map1
     * @param map2
     * @returns {Map<any, any>}
     */
    mergeMaps: function( map1, map2 ) {
        const result = new Map();

        map1.forEach( (value, key) => {
            result.set( key, value );
        });

        map2.forEach( (value, key) => {
            result.set( key, value );
        });

        return result;
    }

};
